const routers = [
    {
        path: '/toLogin',
        name: 'toLogin',
        meta: {
            title: '登录'
        },
        component: (resolve) => require(['./views/toLogin.vue'], resolve),
    }, 
    {
        path: '/',
        name: 'home',
        meta: {
            title: '主页'
        },
        component: (resolve) => require(['./views/index.vue'], resolve),
    },{
        path: '/login',
        name: 'login',
        meta: {
            title: '登录'
        },
        component: (resolve) => require(['./views/login.vue'], resolve)
    },
    {
        path: '/index',
        name: 'index',
        redirect: 'main',
        meta: {
            title: '首页'
        },
        component: (resolve) => require(['./views/index.vue'], resolve),
        children: [{
            path: '/main',
            name: 'main',
            meta: {
                title: '首页',
                isHide: true,
            },
            component: (resolve) => require(['./views/main.vue'], resolve)
        }, {
            path: '/chatBot',
            name: 'chatBot',
            meta: {
                title: 'Prompt管理'
            },
            component: (resolve) => require(['./views/chatBot/list'], resolve)
        }, {
            path: '/agentBot',
            name: 'agentBot',
            meta: {
                title: '代理机器人'
            },
            component: (resolve) => require(['./views/agentBot/list'], resolve)
        }, {
            path: '/namespaceIndex',
            name: 'namespaceIndex',
            meta: {
                title: '知识库概览'
            },
            component: (resolve) => require(['./views/namespace/wait'], resolve)
        }, {
            path: '/namespaceList',
            name: 'namespaceList',
            meta: {
                title: '知识库'
            },
            component: (resolve) => require(['./views/namespace/list'], resolve)
        }, {
            path: '/namespaceFile',
            name: 'namespaceFile',
            meta: {
                title: '知识文档管理'
            },
            component: (resolve) => require(['./views/namespace/file'], resolve)
        }, {
            path: '/namespaceExcel',
            name: 'namespaceExcel',
            meta: {
                title: '关联文件'
            },
            component: (resolve) => require(['./views/namespace/index'], resolve)
        },{
            path: '/chatHistory',
            name: 'chatHistory',
            meta: {
                title: '会话LOG详情'
            },
            component: (resolve) => require(['./views/chatHistory/list'], resolve)
        },{
            path: '/chatHistoryCount',
            name: 'chatHistoryCount',
            meta: {
                title: '会话LOG统计'
            },
            component: (resolve) => require(['./views/chatHistoryCount/list'], resolve)
        },{
            path: '/addBot',
            name: 'addBot',
            meta: {
                title: '新增机器人'
            },
            component: (resolve) => require(['./views/chatBot/add'], resolve)
        },{
            path: '/system',
            name: 'system',
            meta: {
                title: '系统配置'
            },
            component: (resolve) => require(['./views/system/list'], resolve)
        },{
            path: '/greenNet',
            name: 'greenNet',
            meta: {
                title: '禁用语管理'
            },
            component: (resolve) => require(['./views/prohibited/list'], resolve)
        },{
            path: '/greenNetHistory',
            name: 'greenNetHistory',
            meta: {
                title: '禁用语历史'
            },
            component: (resolve) => require(['./views/prohibited/history'], resolve)
        },{
            path: '/log',
            name: 'log',
            meta: {
                title: '日志概览'
            },
            component: (resolve) => require(['./views/chatLog/list'], resolve)
        },{
            path: '/permission',
            name: 'permission',
            meta: {
                title: '权限配置'
            },
            component: (resolve) => require(['./views/permission/list'], resolve)
        }
        ]
    }
];
export default routers;



// WEBPACK FOOTER //
// ./src/router.js